export const COLORS = [
	{ colorID: 1 , color: '#000000' },
  { colorID: 2 , color: '#191970' },
  { colorID: 3 , color: '#00008B' },
  { colorID: 4 , color: '#4682B4' },
  { colorID: 5 , color: '#6495ED' },
  { colorID: 6 , color: '#2F4F4F' },
	{ colorID: 7 , color: '#708090' },
  { colorID: 8 , color: '#8FBC8F' },
  { colorID: 9 , color: '#006400' },
  { colorID: 10, color: '#556B2F' },
  { colorID: 11, color: '#9ACD32' },
  { colorID: 12, color: '#00FF00' },
	{ colorID: 13, color: '#ADFF2F' },
  { colorID: 14, color: '#BDB76B' },
  { colorID: 15, color: '#FFFF00' },
  { colorID: 16, color: '#FFD700' },
  { colorID: 17, color: '#FFA500' },
  { colorID: 18, color: '#FF8C00' },
	{ colorID: 19, color: '#FF7F50' },
  { colorID: 20, color: '#FF6347' },
  { colorID: 21, color: '#FF4500' },
  { colorID: 22, color: '#8B0000' },
  { colorID: 23, color: '#FF0000' },
  { colorID: 24, color: '#FA8072' },
	{ colorID: 25, color: '#8B008B' },
  { colorID: 26, color: '#9370DB' },
  { colorID: 27, color: '#663399' },
  { colorID: 28, color: '#4B0082' },
  { colorID: 29, color: '#808080' },
  { colorID: 30, color: '#696969' }
];


// WEBPACK FOOTER //
// /root/anvel/angular/app/data/colors.ts